import { render } from "./SynchroniseFilePopup.vue?vue&type=template&id=070ced9a&scoped=true&ts=true"
import script from "./SynchroniseFilePopup.vue?vue&type=script&lang=ts"
export * from "./SynchroniseFilePopup.vue?vue&type=script&lang=ts"

import "./SynchroniseFilePopup.vue?vue&type=style&index=0&id=070ced9a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070ced9a"]])

export default __exports__